<template lang="pug" :id="find-store-index-vue">
  .find-store
    banner(page='stores_index_page')
    .title(v-text='$t("retailStore.findStore")')
    .main-description(v-text='$t("bookingService.findStoreDesc")')
    .global-store-message(v-html='globalStoreMessage')
    .search-container(v-if='false')
      input.search(type='text' :placeholder='$t("bookingService.searchPlaceholder")' v-model='searchTerm')
      span.search-icon
    .cities
      .city(v-for='{ stores, city } in filteredStoresByCity' :key='city' v-if="isSortedByState == false")
        .title(v-text='city')
        .store.row(v-for='store in stores' :key='store.id')
          .col-lg-3
            img.store-image(:src='store.attributes.image' @click='gotoStore(store)')
          .col-lg-6
            .title(v-text='getStoreName(store)')
            .description(v-html='replaceNewLineParamterWithBrTag(store)')
            .description(v-text='`${$t("bookingService.phone")}: ${store.attributes.phone}`')
            .store-message
              .description(v-html='store.attributes["store-message"]')
            .hours-container
              .hours(v-for='weekdayHours in coalesceHours(store)' v-text='weekdayHours')
              //- .description.available-services(v-if='hasServices(store)' v-text='$t("bookingService.serviceAvailable", { services: storeServiceProviders(store) })')
          .col-lg-3
            .row
              .col-xs-6.col-lg-12(v-if="showBooxiButton(store) || showTimetradeButton(store) || showBookNowButtonInHouse(store)")
                router-link.btn(:class='{"bth-th": language === "lng_th"}' :to='{ name: "store-location-show", hash: "#beauty-services", params: { id: store.attributes["slug-url"] } }' v-text='$t("bookingService.buttons.bookNow")')
              .col-xs-6.col-lg-12
                router-link.btn.btn-white(:class='{"bth-th": language === "lng_th"}' :to='{ name: "store-location-show", params: { id: store.attributes["slug-url"] }}' v-t='"buttons.moreDetails"')

      .city(v-for='{ stores, state } in filteredStoresByState' :key='state' v-if="isSortedByState == true")
        .title(v-text='state')
        .store.row(v-for='store in stores' :key='store.id')
          .col-lg-3
            img.store-image(:src='store.attributes.image' @click='gotoStore(store)')
          .col-lg-6
            .title(v-text='getStoreName(store)')
            .description(v-html='replaceNewLineParamterWithBrTag(store)')
            .description(v-text='`${$t("bookingService.phone")}: ${store.attributes.phone}`')
            .store-message
              .description(v-html='store.attributes["store-message"]')
            .hours-container
              .hours(v-for='weekdayHours in coalesceHours(store)' v-text='weekdayHours')
              //- .description.available-services(v-if='hasServices(store)' v-text='$t("bookingService.serviceAvailable", { services: storeServiceProviders(store) })')
          .col-lg-3
            .row
              .col-xs-6.col-lg-12(v-if="showBooxiButton(store) || showTimetradeButton(store)")
                router-link.btn(:class='{"bth-th": language === "lng_th"}' :to='{ name: "store-location-show", hash: "#beauty-services", params: { id: store.attributes["slug-url"] } }' v-text='$t("bookingService.buttons.bookNow")')
              .col-xs-6.col-lg-12
                router-link.btn.btn-white(:class='{"bth-th": language === "lng_th"}' :to='{ name: "store-location-show", params: { id: store.attributes["slug-url"] }}' v-t='"buttons.moreDetails"')
    .empty(v-if='isEmpty && !isSortedByState'  v-text='$t("bookingService.nothingFound")')
    .empty(v-if='isEmptyState && isSortedByState'  v-text='$t("bookingService.nothingFound")')
</template>

<i18n>
{
  "lng_en": {
    "bookingService": {
      "metaDescription": "Sephora outlets are present country-wide at prime locations in {country}, to make the best in beauty from around the world easily accessible to you. Find a Sephora store near you now!",
      "findStoreDesc": "Here’s how to locate your nearest Sephora.",
      "searchPlaceholder": "Search by Zip Code, City or State",
      "nothingFound": "Nothing is found",
      "serviceAvailable": "Services Available: {services}",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "buttons": {
        "bookNow": "Book Service"
      }
    }
  },
  "lng_zh": {
    "bookingService": {
      "metaDescription": "Sephora outlets are present country-wide at prime locations in {country}, to make the best in beauty from around the world easily accessible to you. Find a Sephora store near you now!",
      "findStoreDesc": "如何搜尋距離最近的Sephora。",
      "searchPlaceholder": "Search by Zip Code, City or State",
      "nothingFound": "Nothing is found",
      "serviceAvailable": "Services Available: {services}",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "buttons": {
        "bookNow": "預約服務"
      }
    }
  },
  "lng_th": {
    "bookingService": {
      "metaDescription": "Sephora outlets are present country-wide at prime locations in {country}, to make the best in beauty from around the world easily accessible to you. Find a Sephora store near you now!",
      "findStoreDesc": "นี่คือสาขาที่ใกล้คุณที่สุด",
      "searchPlaceholder": "Search by Zip Code, City or State",
      "nothingFound": "Nothing is found",
      "serviceAvailable": "Services Available: {services}",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "buttons": {
        "bookNow": "จองตอนนี้เลย"
      }
    }
  },
  "lng_id": {
    "bookingService": {
      "metaDescription": "Sephora outlets are present country-wide at prime locations in {country}, to make the best in beauty from around the world easily accessible to you. Find a Sephora store near you now!",
      "findStoreDesc": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. ",
      "searchPlaceholder": "Search by Zip Code, City or State",
      "nothingFound": "Nothing is found",
      "serviceAvailable": "Services Available: {services}",
      "flagship": "FLAGSHIP",
      "phone": "Phone",
      "buttons": {
        "bookNow": "Book Service"
      }
    }
  },
  "lng_ko": {
    "bookingService": {
      "metaDescription": "세포라 매장은 현재 {country} 주요 지역에 위치하여 전 세계 다양한 뷰티 브랜드들을 더욱 쉽게 접하실 수 있습니다. 지금 가까운 세포라 매장을 찾아보세요! ",
      "findStoreDesc": "내 위치에서 가장 가까운 세포라 매장을 찾아드립니다. ",
      "searchPlaceholder": "우편번호, 시/도/동으로 검색",
      "nothingFound": "결과를 찾을 수 없습니다",
      "serviceAvailable": "제공 서비스: {services}",
      "flagship": "플래그쉽",
      "phone": "전화",
      "buttons": {
        "bookNow": "서비스 예약하기"
      }
    }
  }
}
</i18n>
<script>

import StoreMixin from './store-mixin'
import { fullUrl } from '@/modules/services/utilities'
import { createNamespacedHelpers } from 'vuex'
import Banner from './reusable/banner.vue'

const { mapGetters, mapState } = createNamespacedHelpers('bookingService')

export default {
  name: 'FindStore',
  components: {
    Banner
  },
  mixins: [StoreMixin],
  props: ['filterGeography'],
  data () {
    return {
      searchTerm: '',
      country: I18n.siteCountryLs,
      language: I18n.language
    }
  },
  computed: {
    ...mapGetters(['storesByCity', 'isSortedByState', 'storesByState']),
    ...mapState([
      'services',
      'categories',
      'globalStoreMessage'
    ]),

    isEmpty () {
      return this.filteredStoresByCity.length === 0
    },
    isEmptyState () {
      return this.filteredStoresByState.length === 0
    },

    filteredStoresByCity () {
      const result = []
      let filteredStores
      for (const { stores, city, slug } of this.storesByCity) {
        if (this.filterGeography !== '' && this.filterGeography !== slug) {
          continue
        }

        filteredStores = stores.filter(this.matchSearch.bind(this))
        if (stores.length > 0) {
          result.push({ stores: filteredStores, city })
        }
      }
      return result
    },
    filteredStoresByState () {
      const result = []
      let filteredStores
      for (const { stores, state, slug } of this.storesByState) {
        if (this.filterGeography !== '' && this.filterGeography !== encodeURIComponent(slug.trim())) {
          continue
        }

        filteredStores = stores.filter(this.matchSearch.bind(this))
        if (stores.length > 0) {
          result.push({ stores: filteredStores, state })
        }
      }
      return result
    }
  },
  mounted () {
    this.$store.commit('setSeoMetaTitle', 'Store Locations')
    const country = this.$t('country', I18n.siteCountryLs)
    this.$store.commit(
      'setSeoMetaDescription',
      this.$t('bookingService.metaDescription', { country: country })
    )
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
    this.$store.commit('setSeoUpdate', true)
  },
  methods: {
    timetradeQueryForStore (store) {
      return {
        locationId: store.attributes['timetrade-location-id']
      }
    },

    gotoStore (store) {
      this.$router.push({ name: 'store-location-show', params: { id: store.attributes['slug-url'] } })
    },

    matchSearch (store) {
      if (!this.searchTerm) {
        return true
      }
      // match zip code, city or state
      const { name, postal, city } = store.attributes
      const search = target => target.toLowerCase().indexOf(this.searchTerm.toLowerCase()) >= 0
      return search(name) || search(postal) || search(city)
    },

    hasServices (store) {
       return this.services.length > 0
    },

    storeServiceProviders (store) {
      for (let i = 0; i < this.services.length; i++) {
        for (let j = 0; j < this.services[i]['attributes']['activity-groups'].length; j++) {
            if (this.filteredCategories.some(x => x.id === this.services[i]['attributes']['activity-groups'][j]['id'])) {
              continue
            }
          const val = this.categories.find(category => (category.id === this.services[i]['attributes']['activity-groups'][j]['id']))
          if (typeof val !== 'undefined') {
            this.filteredCategories.push(
              val
            )
          }
      }
    }
      // fetch ids from all services
      // const serviceIds = store.relationships.services.data.map(s => s.id)

      // // Check if a service id included in our service ids
      // const includedInServiceIds = includedIn(serviceIds)

      // const getCategoryIdsFromService = (service) => service.relationships.category.data.id

      // // Filter for category ids
      // const categoryIds = this.services.filter(includedInServiceIds).map(getCategoryIdsFromService)
      // const includedInCategoryIds = includedIn(categoryIds)

      // // Filter by category ids and join category names by comma
      // const commaSeparatedCategoryNames = this.categories.filter(includedInCategoryIds).map(cat => cat.attributes.name).join(', ')

      // return commaSeparatedCategoryNames
    },
    showTimetradeButton (store) {
      return store.attributes['timetrade-location-id'] !== '' && store.attributes['has-bookable']
    },
    showBooxiButton (store) {
      return store.attributes['booxi-api-key'] !== '' && store.attributes['has-bookable']
    },
    showBookNowButtonInHouse (store) {
      return store.attributes['timetrade-location-id'] === '' && store.attributes['booxi-api-key'] === '' && store.attributes['has-bookable']
    },
    replaceNewLineParamterWithBrTag (store) {
      return store.attributes['address'].replace(/\n/g, '<br />')
    }
  }
}
</script>

<style scoped lang='scss'>
  $spacer: 10px;

  .main-description {
    margin-bottom: $spacer * 2;
  }

  .global-store-message {
    margin-bottom: $spacer * 2;
  }

  .search {
    font-size: 17px;
    border: none;
    flex: 1 1 auto;
    color: $grey-dark;
    &:focus {
      outline: none;
    }
  }

  .search-container {
    border: 1px solid $grey-light;
    display: flex;
    padding: 6px 0 6px 10px;
    margin: 20px 0;
    width: 100%;
  }

  .search-icon {
    height: 20px;
    width: 20px;
    align-self: center;
    margin-right: 4px;
    background-image: url('../../assets/images/icons/search-grey-light.svg');
    background-position: center;
  }

  .store-image {
    width: 100%;
    height: auto;
    margin-bottom: 10px;

    &:hover {
      cursor: pointer;
    }
  }

  .store {
    line-height: 20px;
    padding: 10px;
    margin: 20px 0;
    border: 1px solid $grey-light;

    .store-message {
      margin-top: 20px;
    }

    .hours-container {
      margin-top: 20px;
      margin-bottom: 10px;
    }

    .btn {
      display: block;

      @include media-breakpoint-up(lg) {
        margin-top: 10px;
      }

      @include media-breakpoint-down(xs) {
        font-size: 95%;
      }
    }

    .bth-th {
      @include media-breakpoint-down(md) {
        font-size: 80%;
      }
    }

    .available-services {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .city {
    padding-left: 0;
    margin-top: 0;
    padding-top: 20px;
    border-bottom: 1px solid $grey-light;
  }

  .cities {
    border-top: 1px solid $grey-light;

    @include media-breakpoint-down(md) {
      display: block;
    }
  }

  .title {
    font-weight: bold;
    font-size: 15px;
    line-height: 16px;
    margin-bottom: 4px;
  }

  .empty {
    margin-top: 10px;
  }

  @include media-breakpoint-down(sm) {
    .find-store {
      padding: 10px;
    }
  }
</style>
